export const shouldLoad = () => document.querySelector('.klt-modal') !== undefined;